'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubNubMessageRecordInvariant = undefined;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _CommentMessage = require('../comment-message-metadata/records/CommentMessage');

var _CommentMessage2 = _interopRequireDefault(_CommentMessage);

var _CommonMessage = require('../common-message-format/records/CommonMessage');

var _CommonMessage2 = _interopRequireDefault(_CommonMessage);

var _ContextUpdateMessage = require('../context-update/records/ContextUpdateMessage');

var _ContextUpdateMessage2 = _interopRequireDefault(_ContextUpdateMessage);

var _CrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate2 = _interopRequireDefault(_CrmObjectLifecycleUpdate);

var _InitialMessage = require('../initial-message/records/InitialMessage');

var _InitialMessage2 = _interopRequireDefault(_InitialMessage);

var _getRecordName = require('../lib/getRecordName');

var _PubNubMessageRecord = require('../pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supportedRecords = [_PubNubMessageRecord2.default, _CommonMessage2.default, _ContextUpdateMessage2.default, _CrmObjectLifecycleUpdate2.default, _CommentMessage2.default, _InitialMessage2.default];

var pubNubMessageRecordInvariant = exports.pubNubMessageRecordInvariant = function pubNubMessageRecordInvariant(message) {
  return (0, _invariant2.default)(supportedRecords.some(function (record) {
    return message instanceof record;
  }), 'Expected message to be one of ' + supportedRecords.map(_getRecordName.getRecordName));
};